<div class="container-fluid pb-5">

  <!-- Filters -->
  <div class="d-flex gap-2 mb-3">

    <!-- Date Range -->
    <mat-form-field appearance="outline" class="col-md-6">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Centre Multi-Select -->
    <app-searchable-select class="col-md-4"
                           [multiple]="true"
                           [hideSelectAllOption]="false"
                           [options]="centres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)">
    </app-searchable-select>

    <!-- Search & Clear Buttons -->
    <div class="d-flex align-items-center gap-2">
      <button mat-mini-fab color="accent" (click)="searchByDateAndCentre()">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-mini-fab color="warn" (click)="clearAllFilters()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

  </div>

  <!-- Table -->
  <h1 class="text-center">Session Count Table</h1>

<!--  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">-->

<!--    &lt;!&ndash; Sr No &ndash;&gt;-->
<!--    <ng-container matColumnDef="srNo">-->
<!--      <th mat-header-cell *matHeaderCellDef rowspan="2">Sr No</th>-->
<!--      <td mat-cell *matCellDef="let element">{{element.srNo}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Centre Name &ndash;&gt;-->
<!--    <ng-container matColumnDef="centreName">-->
<!--      <th mat-header-cell *matHeaderCellDef rowspan="2">Centre</th>-->
<!--      <td mat-cell *matCellDef="let element">{{element.centreName}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; New Individual &ndash;&gt;-->
<!--    <ng-container matColumnDef="newIndividual">-->
<!--      <th mat-header-cell *matHeaderCellDef>Individual</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.newIndividual)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; New Group &ndash;&gt;-->
<!--    <ng-container matColumnDef="newGroup">-->
<!--      <th mat-header-cell *matHeaderCellDef>Group</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.newGroup)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; New Assessment &ndash;&gt;-->
<!--    <ng-container matColumnDef="newAssessment">-->
<!--      <th mat-header-cell *matHeaderCellDef>Assessment</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.newAssessment)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Follow Individual &ndash;&gt;-->
<!--    <ng-container matColumnDef="followIndividual">-->
<!--      <th mat-header-cell *matHeaderCellDef>Individual</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.followIndividual)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Follow Group &ndash;&gt;-->
<!--    <ng-container matColumnDef="followGroup">-->
<!--      <th mat-header-cell *matHeaderCellDef>Group</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.followGroup)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Follow Assessment &ndash;&gt;-->
<!--    <ng-container matColumnDef="followAssessment">-->
<!--      <th mat-header-cell *matHeaderCellDef>Assessment</th>-->
<!--      <td mat-cell *matCellDef="let element">{{formatZero(element.followAssessment)}}</td>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Top Header Row &ndash;&gt;-->
<!--    <ng-container matColumnDef="newHeader">-->
<!--      <th mat-header-cell *matHeaderCellDef colspan="3" class="text-center">New Children</th>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="followHeader">-->
<!--      <th mat-header-cell *matHeaderCellDef colspan="3" class="text-center">Follow-up Children</th>-->
<!--    </ng-container>-->

<!--    &lt;!&ndash; Header rows &ndash;&gt;-->
<!--    <tr mat-header-row *matHeaderRowDef="headerRow1"></tr>-->
<!--    <tr mat-header-row *matHeaderRowDef="headerRow2"></tr>-->

<!--    &lt;!&ndash; Data row &ndash;&gt;-->
<!--    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->

<!--  </table>-->
  <table mat-table [dataSource]="dashboardSource" class="mat-elevation-z1">
    <ng-container  matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef> Sr No </th>
      <td mat-cell *matCellDef="let i=index">{{i+1}} </td>
    </ng-container>

    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre </th>
      <td mat-cell *matCellDef="let row"> {{row.centreName}} </td>
    </ng-container>

    <ng-container matColumnDef="admission">
      <th mat-header-cell *matHeaderCellDef> Admission </th>
      <td mat-cell *matCellDef="let row"> {{row.admission}} </td>
    </ng-container>

    <ng-container matColumnDef="regular">
      <th mat-header-cell *matHeaderCellDef> Regular </th>
      <td mat-cell *matCellDef="let row"> {{row.regular}} </td>
    </ng-container>

    <ng-container matColumnDef="discharge">
      <th mat-header-cell *matHeaderCellDef> Discharge </th>
      <td mat-cell *matCellDef="let row"> {{row.discharge}} </td>
    </ng-container>

    <ng-container matColumnDef="followup">
      <th mat-header-cell *matHeaderCellDef> Follow-up </th>
      <td mat-cell *matCellDef="let row"> {{row.followup}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="dashboardColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: dashboardColumns"></tr>

  </table>

</div>
